import Header from '../../components/common/header/index.vue'
import axios from 'axios'
import { encryptRSA } from '../../util/rsa'
import { validatePasswordStrength } from '../../util/password'
export default {
  name: 'login',
  components: { Header },
  data () {
    // 账户校验
    const validateAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入' + this.ActOrEmail))
      } else {
        callback()
      }
    }
    // 密码校验
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    // 邮箱校验
    const validateEmail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (value === '') {
        callback(new Error('请输入邮箱'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的邮箱'))
      } else {
        callback()
      }
    }
    // 用户名校验
    const validateName = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else if (value.length > 20) {
        callback(new Error('内容过长，请输入20个字符内的用户名！'))
      } else if (!reg.test(value)) {
        callback(new Error('用户名只支持英文字母和数字！'))
      } else {
        callback()
      }
    }

    // 真实姓名校验
    const validateUserName = (rule, value, callback) => {
      const reg = /^(?:[\u4e00-\u9fa5·]{2,16})$/
      if (value === '') {
        callback(new Error('请输入真实姓名'))
      } else if (value.length > 10) {
        callback(new Error('真实姓名输入10字以内'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的姓名！'))
      } else {
        callback()
      }
    }

    // 手机号校验
    const validatePhone = (rule, value, callback) => {
      const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的手机号！'))
      } else {
        callback()
      }
    }
    // 注册密码校验
    const validateRegisterPass = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.registerForm.name)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else {
        if (this.registerForm.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    // 确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      const errorMessage = validatePasswordStrength(value, this.registerForm.name)
      if (errorMessage) {
        callback(new Error(errorMessage))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    // 验证码校验（注册必填）
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      // 其它子系统返回的url
      url: '',
      yzmUrl: '',
      // 登录和注册切换
      loginOrRegister: 'login',
      // 账户登录还是邮箱登录
      ActOrEmail: '用户名',
      // 登录的form对象
      loginForm: {
        name: '',
        password: '',
        code: ''
      },
      // 注册的form对象
      registerForm: {
        email: '',
        name: '',
        userName: '',
        phone: '',
        password: '',
        confirmPassword: '',
        code: ''
      },
      // 忘记密码的form对象
      forgotForm: {
        mail: '',
        name: ''
      },
      // 登录的校验规则
      loginrules: {
        name: [
          { validator: validateAccount, trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      // 注册的校验规则
      registerRules: {
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        name: [
          { validator: validateName, trigger: 'blur' }
        ],
        userName: [
          { validator: validateUserName, trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { validator: validateRegisterPass, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ]
      },

      forgotRules: {
        mail: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        name: [
          { validator: validateName, trigger: 'blur' }
        ]
      },
      countdown: 5,
      // 注册防重复提交标志
      registering: false
    }
  },
  // 创建元素
  mounted () {
    this.init()
    this.getUrl()
    this.getYzm()
  },
  // 方法定义
  methods: {
    init () {
      if (this.$route.query.loginOrRegister) {
        this.loginOrRegister = this.$route.query.loginOrRegister
      } else {
        this.loginOrRegister = 'login'
      }
    },

    getYzm () {
      const self = this
      axios.get('/yuhuamenhu/yzm/getyzm', { responseType: 'blob' }).then(json => {
        if (json.data.type === 'application/json') {
          self.getYzm() // 非图片响应（如验证码过期）→ 静默刷新，不渲染不打印
          return
        }
        self.yzmUrl = window.URL.createObjectURL(json.data)
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取url
    getUrl () {
      const query = this.$route.query
      if (query.url) {
        this.url = query.url
      } else {
        this.url = ''
      }
    },

    // 登录和注册切换
    handleLoginOrRegister (param) {
      this.loginOrRegister = param
      if (param === 'register') {
        this.$refs.loginForm.resetFields()
        this.getYzm() // 切到注册页时刷新验证码，防止复用旧验证码
      } else {
        this.$refs.registerForm.resetFields()
      }
    },
    // 账户和邮箱切换
    loginActOrEmail (param) {
      this.ActOrEmail = param
      this.$refs.loginForm.resetFields()
    },

    // 点击登录
    submitLogin (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginAccount()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 登录接口
    loginAccount () {
      const self = this
      let urlLogin = ''
      // 盐值
      // const salt = 'cnki-yyds*123.cv987@'
      const data = {
        password: encryptRSA(self.loginForm.password),
        url: self.url,
        code: self.loginForm.code
      }
      if (self.ActOrEmail === '用户名') {
        urlLogin = '/yuhuamenhu/user/loginByName'
        data.name = self.loginForm.name
      } else {
        urlLogin = '/yuhuamenhu/user/loginByMail'
        data.mail = self.loginForm.name
      }
      axios.post(urlLogin, data).then(json => {
        if (json.data.code === 200 || json.data.code === 6) {
          if (json.data.code === 6) {
            self.$message.warning(json.data.errorMessage)
          }
          self.$store.commit('set_Authorization', json.data.data.Authorization)
          self.$store.commit('set_name', json.data.data.name)
          self.$store.commit('set_userName', json.data.data.userName)
          self.$store.commit('set_userType', json.data.data.userType)
          self.$store.commit('set_userKind', json.data.data.userKind)
          if (json.data.data.isPasswordExpired) {
            self.$message.warning('密码已超过90天未更换，请先修改密码')
            // 安全加固：不再把 token 放入 URL query（防 token 进浏览器历史/Referer/服务器日志）
            // token 已在上面 commit 到 store，/reset 页面从 store 读取
            self.$router.replace({
              path: '/reset',
              query: {
                name: json.data.data.name,
                forceChange: '1'
              }
            })
            return
          }
          if (json.data.data.url) {
            window.location.href = json.data.data.url
          } else {
            self.$router.push('/')
          }
          self.url = ''
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击注册
    submitRegister (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.RegisterAccount()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 注册账号接口
    RegisterAccount () {
      const self = this
      // 防重复提交：请求未结束前禁止再次点击（配合模板 registering 置灰）
      if (this.registering) {
        return
      }
      this.registering = true
      // const salt = 'cnki-yyds*123.cv987@'
      const data = {
        mail: this.registerForm.email,
        name: this.registerForm.name,
        userName: this.registerForm.userName,
        phone: this.registerForm.phone,
        password: encryptRSA(this.registerForm.password),
        code: this.registerForm.code // 图形验证码（配合后端校验，防自动化批量注册）
      }
      axios.post('/yuhuamenhu/user/save', data).then(json => {
        if (json.data.code === 200) {
          this.loginOrRegister = 'registerSuccess'
        } else {
          self.$message.warning(json.data.errorMessage)
          self.getYzm() // 注册失败：刷新验证码并清空输入，防止验证码被复用
          self.registerForm.code = ''
        }
      }).catch(err => {
        console.log(err)
        self.getYzm()
        self.registerForm.code = ''
      }).finally(() => {
        self.registering = false
      })
    },

    // 返回首页
    goHome () {
      this.$router.push('/')
    },

    // 点击忘记密码
    loginForgot () {
      this.loginOrRegister = 'forgotPassword'
    },

    // 点击提交申请
    submitForgot (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.forgetPassword()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    forgetPassword () {
      const self = this
      const data = {
        mail: this.forgotForm.mail,
        name: this.forgotForm.name
      }
      axios.post('/yuhuamenhu/user/forgetPassword', data).then(json => {
        if (json.data.code === 200) {
          this.loginOrRegister = 'forgotSuccess'
          this.countdown = 5
          this.countDown()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    countDown () {
      if (this.countdown > 1) {
        this.countdown--
        setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.goHome()
      }
    }
  }
}
